import { TransferDetailsContext } from '@context/TransferDetailsContext';
import { formatDateWithTime } from '@helpers/Date';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Grid, Typography, useTheme } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

const StatusRefreshedBar = () => {
	const theme = useTheme();
	const { t } = useTranslation();
	const { statusRefreshedAt }: any = useContext(TransferDetailsContext);
	return (
		<>
			<Grid container direction="row">
				<Grid item xs={12}>
					<Grid container alignItems="center">
						<RefreshIcon fontSize="small" />
						<Typography color={theme.text.secondary} variant="body2" sx={{ fontWeight: '600', pl: '4px' }}>
							{t('LAST_REFRESHED_STATUS')}
						</Typography>
						<Typography color={theme.text.tertiary} variant="body2" sx={{ fontWeight: '700', pl: '4px' }}>
							{statusRefreshedAt ? formatDateWithTime(statusRefreshedAt) : 'N/A'}
						</Typography>
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};

export default StatusRefreshedBar;
